import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/auth.css";
import { useI18n } from "../providers/I18nProvider";
import { API_BASE_URL } from "../config";

const ForgotPasswordPage = () => {
  const { t } = useI18n();

  // Login sayfasındaki gibi: ortalanmış kart + arka plan (body.login-body)
  useEffect(() => {
    document.body.classList.add("login-body");
    return () => document.body.classList.remove("login-body");
  }, []);
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/request-password-reset`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email }),
      });
      const data = await res.json().catch(() => ({}));
      setStatus({
        type: res.ok ? "ok" : "err",
        message: data?.msg || (res.ok ? t("auth.forgotPassword.sent") : t("common.genericError")),
      });
    } catch (err) {
      setStatus({ type: "err", message: err.message || t("common.genericError") });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card" role="main">
        <div className="auth-brand" aria-hidden="true">
          <div className="auth-brand-inner">
            <img
              className="auth-logo-image"
              src={`${process.env.PUBLIC_URL}/altust_renk.png`}
              alt={t("auth.logoAlt")}
              loading="eager"
              decoding="async"
            />
          </div>
        </div>
        <div className="auth-panel">
          <h2 className="auth-title">{t("auth.forgotPassword.title")}</h2>
          <p className="muted" style={{ marginTop: 0 }}>
            {t("auth.forgotPassword.subtitle")}
          </p>
          <form className="auth-form" onSubmit={submit}>
            <div className="auth-field">
              <label className="auth-label" htmlFor="forgot-email">
                {t("auth.email")}
              </label>
              <input
                id="forgot-email"
                type="email"
                inputMode="email"
                autoComplete="email"
                placeholder={t("auth.email")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button type="submit" disabled={loading}>
              {loading ? t("common.loading") : t("auth.forgotPassword.submit")}
            </button>
            {status.message && (
              <div className={status.type === "ok" ? "success-box" : "error-box"}>
                {status.message}
              </div>
            )}
          </form>
          <div style={{ marginTop: 12 }}>
            <Link to="/login">{t("auth.forgotPassword.backToLogin")}</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;

